import type { z } from 'zod';

import env from '../../env';
import { createApi } from '../core';
import { HubPersonalization } from '../types/personalization';

type HubPersonalizationData = z.infer<typeof HubPersonalization>;

export const personalizationApi = createApi.group(['personalization'], (createKey) => {
  return {
    personalizationContent: createApi.query({
      queryKey: createKey(['personalizationContent']),
      queryFn: async (): Promise<HubPersonalizationData> => {
        const url = env.REACT_APP_PERSONALIZATION_URL?.trim();
        if (!url) {
          return HubPersonalization.parse({});
        }

        const res = await fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          },
        });

        if (!res.ok) {
          throw new Error(res.statusText || 'Failed to load personalization');
        }

        const raw: unknown = await res.json();
        return HubPersonalization.parse(raw);
      },
      staleTime: createApi.time(1, 'minutes'),
      refetchInterval: createApi.time(1, 'minutes'),
    }),
  };
});
